import React, {FC} from 'react';

interface IStatTileProps {
  label: string;
  value: React.ReactNode;
  hint?: React.ReactNode;
  tone?: 'default' | 'warn' | 'ok';
}

const VALUE_TONES = {
  default: 'text-[#33364b]',
  warn: 'text-[#c2410c]',
  ok: 'text-[#1f7a4c]',
};

export const StatTile: FC<IStatTileProps> = ({label, value, hint, tone = 'default'}) => (
  <div className="rounded-lg border border-[#ebecf0] bg-white p-4">
    <div className="text-[11px] uppercase tracking-wide text-gray-400">{label}</div>
    <div className={`mt-1 text-xl font-medium ${VALUE_TONES[tone]}`}>{value}</div>
    {hint && <div className="mt-0.5 text-[12px] text-gray-500">{hint}</div>}
  </div>
);
